'use client'

import dynamic from 'next/dynamic'
import type { TapSwapWidgetProps } from './tap-swap-widget'

// The swap UI is a custom Uniswap v4 module that pulls in wagmi/viem/permit2,
// so we keep the dynamic import + `ssr: false` to defer the chunk until the
// user actually opens the Swap tab — the rest of the app is Bitcoin-only and
// shouldn't pay the bundle cost.
const TapSwapWidget = dynamic<TapSwapWidgetProps>(
	() => import('./tap-swap-widget').then((mod) => mod.TapSwapWidget),
	{ ssr: false, loading: () => null }
)

export function TapSwapWrapper({ compact = false, iconUrl }: TapSwapWidgetProps) {
	return <TapSwapWidget compact={compact} iconUrl={iconUrl} />
}
